export default "<template>\n    <div>\n        Empty sample\n    </div>\n</template>"